export class GetUserRequestParams {
  pageNo: number = 1;
  rowPerPage: number = 10;
  filter: string = '';
  //bankCode: string = '';
  roleId: string | null = null;
  merchantId: string | null = null;
}

export class CreateUserParams {
  name: string = '';
  email: string = '';
  phone: string = '';
  client_id: string = '';
  roles: string[] = [];
}

export class UpdateUserRequestParams extends CreateUserParams {
  oldPassword?: string;
  password?: string;
}

export interface UserRole {
  name: string;
  code: string;
  id: string;
}

export interface UserMerchant {
  name: string;
  user: string;
  id: string;
  code: string;
  balance: number;
}

export interface UserData {
  id: string;
  name: string;
  email: string;
  phone: string;
  client_id: string;
  client_name: string;
  roles: UserRole[];
  FirstName: string;
  LastName: string;
  FullName: string;
  Nik: string;
  Gender: string;
  merchant: UserMerchant;
  merchants: UserMerchant[];
}

export interface GetUserResponse {
  code: number;
  message: string;
  data: UserData[];
  currPage: number;
  haveNext: boolean;
  totalPage: number;
}

export interface GetUserByIdResponse {
  code: number;
  message: string;
  data: UserData;
}

export interface DeleteUserByIdResponse {
  code: number;
  message: string;
  data: boolean;
}
